import { toastError } from '../../../../utils';
import { callApi } from '../../../../apiCaller';
import { COURSE_STATUS } from '../../../../constants';

import { updateCourseRequest } from '../../../CMS/Subscriber/MyLeaning/Course/actions';
import { setUserLesson, setUserLessons } from '../../../CMS/Subscriber/GlobalStates/UserLesson/actions';

export const SET_LESSON_VIDEO_REF = 'setLessonVideoRef';
export const API_SUBSCRIBER_USER_LESSON_VIDEO_PROGRESS = 'user/lesson/video-progress/:id';

export const setLessonVideoRef = (payload) => {
     return {
          type: SET_LESSON_VIDEO_REF,
          payload,
     };
};

export const updateVideoProgressRequest = (userLessonParams, payload) => async (dispatch, getState) => {
     const courses = getState().subscriber.courses;
     const userLesson = getState().subscriber.userLesson;
     const userLessons = getState().subscriber.userLessons;

     const { userLessonId, courseId, product } = userLessonParams;
     const productId = product?.id ?? '';

     callApi(API_SUBSCRIBER_USER_LESSON_VIDEO_PROGRESS.replace(':id', userLessonId), 'PUT', payload).then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const newUserLesson = {
               ...userLesson,
               status: response.data.status,
               videoProgressed: response.data.videoProgressed ?? 0,
          };

          const newUserLessons = userLessons.map((userLesson) => {
               if (userLesson.id !== newUserLesson.id) {
                    return userLesson;
               }

               if (!newUserLesson?.lessons?.productId && productId) {
                    newUserLesson.lessons = {
                         productId,
                    };
               }

               return { ...userLesson, ...newUserLesson };
          });

          dispatch(setUserLesson(newUserLesson));
          dispatch(setUserLessons(newUserLessons));

          if (!courseId) {
               return;
          }

          const productUserLessons = newUserLessons.filter((userLesson) => userLesson.lessons?.productId === productId);
          const everyUserLessonComplete = productUserLessons.every((productUserLesson) => productUserLesson.status === COURSE_STATUS.COMPLETED);

          if (everyUserLessonComplete && product?.lessons?.length === productUserLessons.length) {
               dispatch(updateCourseRequest(courseId, { lessonStatus: COURSE_STATUS.COMPLETED }));
               return;
          }

          const allowLessonStatus = [COURSE_STATUS.IN_PROGRESS, COURSE_STATUS.COMPLETED];
          const course = courses.find((course) => course.id === courseId);

          if (!everyUserLessonComplete && !allowLessonStatus.includes(course?.lessonStatus)) {
               dispatch(updateCourseRequest(courseId, { lessonStatus: COURSE_STATUS.IN_PROGRESS }));
          }
     });
};
